<template>
    <v-list-item :to="{ name: 'M_Morse code' }" :disabled="disabled">
        <v-list-item-icon>
            <v-icon>mdi-alphabetical</v-icon>
        </v-list-item-icon>
        
        <v-list-item-content>
            <v-list-item-title>Morse code</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
export default {
    name: 'mNavItemMorseCode',
    props: {
        disabled: Boolean,
    }
}
</script>